export default {
  alignCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  chat: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  chatMessagesContainer: {
    padding: '0 0 0 10px',
    borderTop: '1px solid #EDEDED',
    backgroundColor: '#FCFCFC',
    height: 'calc(100% - 28px)',
    boxShadow: 'inset 0px 10px 8px -10px rgba(214, 214, 214, 0.7), inset 0px -10px 8px -10px rgba(214, 214, 214, 0.7)',
  },
  chatMessagesRow: {
    overflowY: 'auto',
    overflowX: 'hidden',
    height: '100%',
  },
  chatRecipient: {
    display: 'inline-flex',
    fontWeight: 'bold',
    marginLeft: '10px',
    marginTop: '5px',
    marginBottom: '5px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  muteContactIcon: {
    fontSize: '18px',
    cursor: 'pointer',
    color: '#878787',
    '&:hover': {
      color: '#4c4c4c',
    },
  },
  chatTabLabel: { lineHeight: '0', fontSize: '11px', display: 'flex', alignItems: 'center' },
  chatTabIndicator: {
    height: '1px',
  },
  chatTabUnreadMessages: {
    marginLeft: '10px',
    borderRadius: '100%',
    background: 'red',
    color: '#fff',
    width: '15px',
    height: '14px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '11px',
  },
  chatTabSelected: {
    background: 'lightblue',
    color: '#fff',
  },
  chatMessagesContainerInner: {
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    paddingRight: '10px',
    paddingTop: '10px',
    height: 'calc(100% - 10px)',
    '&::-webkit-scrollbar': {
      width: '3px',
      background: 'rgba(0,0,0, 0.2)',
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(0,0,0, 0.4)',
      borderRadius: '10px',
    },
  },
  chatInputContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  chatMsgRow: {
    display: 'flex',
    //marginBottom: '10px',
    flexShrink: '0',
    alignItems: 'center',
  },
  chatMsgRowIncome: {
    justifyContent: 'flex-start',
  },
  chatMsgRowOutcome: {
    justifyContent: 'flex-end',
  },
  chatMsg: {
    padding: '10px',
    flexShrink: '0',
    borderRadius: '5px',
    width: '80%',
    '&:hover': {
      '& .not-seen-container': {
        display: 'flex',
      },
    },
  },
  chatMsgContent: {
    //overflowX: 'hidden',
    textOverflow: 'ellipsis',
    marginTop: '0',
    marginBottom: '0',
  },
  chatMsgFirst: {
    marginBottom: '10px',
    width: '100%',
    boxSizing: 'border-box',
  },
  chatMsgRecipient: {
    marginRight: '10px',
  },
  chatDateContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '10px',
    color: '#62615C',
    fontWeight: 'bold',
  },
  chatMsgDate: {
    fontSize: '11px',
  },
  chatMsgImagesBlock: {
    display: 'flex',
    height: '104px',
    paddingTop: '10px',
    marginTop: '10px',
    borderTop: '1px solid #fff',
  },
  chatMsgImage: {
    width: '100%',
    outline: '2px solid coral',
    maxHeight: '100px',
  },
  chatMsgImageLink: {
    width: '75px',
    marginRight: '10px',
  },
  chatMsgFilesBlock: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '10px',
    marginTop: '10px',
    borderTop: '1px solid #fff',
  },
  chatMsgErrorBlock: {
    color: 'red',
    paddingTop: '10px',
    marginTop: '10px',
    borderTop: '1px solid #fff',
  },
  chatMsgBtnsBlock: {
    display: 'flex',
    flexWrap: 'wrap',
    paddingTop: '10px',
    marginTop: '10px',
    borderTop: '1px solid #fff',
  },
  chatMsgFile: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flexShrink: '0',
  },
  chatMsgPidsBlock: {
    display: 'flex',
    paddingTop: '10px',
    marginTop: '10px',
    borderTop: '1px solid #fff',
    flexWrap: 'wrap',
  },
  chatMsgIncome: {
    background: '#E1F4FA',
  },
  chatMsgOutcome: {
    background: '#EEECF8',
  },
  deleteIcon: {
    color: 'red',
  },
  chatMsgEyeIcon: {
    color: 'gray',
    fontSize: '16px',
    '&:hover': {
      cursor: 'pointer',
      opacity: 1,
    },
  },
  chatMsgEyeIconNotSeen: {
    opacity: 0.8,
    position: 'relative',
    zIndex: 1,
  },
  chatMsgEyeIconContainer: {
    position: 'relative',
    display: 'none',
    height: '0',
  },
  chatMsgEyeIconLine: {
    position: 'absolute',
    top: '8px',
    zIndex: '0',
    left: '-1px',
    width: '20px',
    height: '1px',
    background: 'gray',
    transform: 'rotate(45deg)',
  },
  chatInput: {
    width: '100%',
    marginBottom: '10px',
    padding: '10px',
    boxSizing: 'border-box',
    border: '1px solid #ccc',
    fontSize: '12px',
  },
  chatSelect: {
    width: '150px',
    fontSize: '12px',
    marginLeft: '5px',
  },
  chatSelectIcon: {
    top: '1px',
  },
  chatSelectItem: {
    fontSize: '14px',
  },
  chatInfoContainer: {
    flexShrink: '0',
    padding: '10px',
  },
  chatInfoRow: {
    display: 'flex',
  },
  chatInfoTable: {
    width: '100%',
  },
  chatInfoText: {
    width: '40px',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    display: 'inline-block',
  },
  chatInfoInput: {
    fontSize: '12px',
    border: 'none',
    background: 'transparent',
    width: '81%',
  },
  chatInfoInputError: {
    color: 'red',
  },
  chatUploadBtn: {
    zoom: '0.8',
    marginRight: '25px',
    flexShrink: '0',
  },
  chatSymbolsLeft: {
    marginRight: '25px',
    flexShrink: '0',
  },
  chatImagesToUpload: {
    margin: '6px 0',
    display: 'flex',
  },
  chatUploadedImgContainer: {
    position: 'relative',
    border: '1px solid #ccc',
    marginRight: '5px',
  },
  chatUploadedImgRemoveIconContainer: {
    position: 'absolute',
    top: '-6px',
    right: '-6px',
    background: 'red',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '100%',
    color: '#fff',
    width: '15px',
    height: '15px',
    zIndex: '1',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  chatUploadedImgRemoveIcon: {
    fontSize: '11px',
  },
  chatBtnsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  chatTemplateContainer: {
    width: '124px',
  },
  chatTemplateText: {
    marginBottom: '2px',
  },
  chatPidsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    marginLeft: '5px',
  },
  chatPid: {
    display: 'flex',
    alignItems: 'center',
    padding: '1px 4px',
    marginRight: '2px',
    fontSize: '10px',
    background: '#fff',
    color: 'black',
    borderRadius: '20px',
    // maxHeight: '20px',
    marginBottom: '2px',
    border: '1px solid #ededed',
    '&:hover': {
      cursor: 'default',
    },
  },
  chatRemovePidIcon: {
    color: 'red',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  chatEmptyText: {
    fontSize: '15px',
    color: '#C2C2C2',
  },
  chatSettingsIcon: {
    color: '#ccc',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  chatSendBtn: {
    marginLeft: '10px',
    zoom: '0.8',
  },
  '@media (max-width: 900px)': {
    chatMessagesContainerInner: {
      height: '250px',
    },
    chatInfoText: {
      fontSize: '10px',
    },
    chatInfoInput: {
      fontSize: '10px',
      width: 'auto',
    },
    chatSelect: {
      width: '100px',
    },
  },
};
